<template>
  <ul class="tower-info-list">
    <li>
      <span>经度:</span>
      <el-input
        v-if="edit"
        v-model="info.lon"
        @blur="e => handleBlur(e, 'lon')"
        @keyup.enter.native="e => handleBlur(e, 'lon')"
      ></el-input>
      <span v-else>{{ (info && info.lon) || '-' }}</span>
    </li>
    <li>
      <span>纬度:</span>
      <el-input
        v-if="edit"
        v-model="info.lat"
        @blur="e => handleBlur(e, 'lat')"
        @keyup.enter.native="e => handleBlur(e, 'lat')"
      ></el-input>
      <span v-else>{{ (info && info.lat) || '-' }}</span>
    </li>
    <li>
      <span>海拔:</span>
      <el-input
        v-if="edit"
        v-model="info.altitude"
        @blur="e => handleBlur(e, 'altitude')"
        @keyup.enter.native="e => handleBlur(e, 'altitude')"
      ></el-input>
      <span v-else>{{ (info && info.altitude) || '-' }} m</span>
    </li>
    <li v-if="scene==='plan'">
      <span>折减系数:</span>
      <span style="width:95px">{{ (info && info.synthesizeLoss) || '-' }} (除尾流)</span>
    </li>
    <li v-else>
      <span>尾流折减:</span>
      <span style="width:95px">{{ (info && info.flowLoss) || '-' }} %</span>
    </li>
    <li>
      <span>理论发电量:</span>
      <span style="width:95px">{{ (info && info.annualEnergy) || '-' }} MWh</span>
    </li>
    <li>
      <span>满发小时数:</span>
      <span>{{ (info && info.fullLoadHour) || '-' }} h</span>
    </li>
    <li>
      <span>平均风速:</span>
      <span>{{ (info && info.wspd) || '-' }} m/s</span>
    </li>
    <li>
      <span>平均气温:</span>
      <span>{{ (info && info.t) || '-' }} ℃</span>
    </li>
    <li>
      <span>A:</span>
      <span>{{ (info && info.weibullA) || '-' }}</span>
    </li>
    <li>
      <span>K:</span>
      <span>{{ (info && info.weibullK) || '-' }}</span>
    </li>
    <li>
      <span>功率密度:</span>
      <span>{{ (info && info.powerDensity) || '-' }} W/㎡</span>
    </li>
    <li>
      <span>空气密度:</span>
      <span>{{ (info && info.density) || '-' }} kg/m³</span>
    </li>
    <li>
      <span>风切变:</span>
      <span>{{ (info && info.shear) || '-' }}</span>
    </li>
    <li>
      <span>主风向:</span>
      <span>{{ (info && info.mainDir) || '-' }}</span>
    </li>
  </ul>
</template>
<script>
export default {
  props: {
    turbine: {
      type: Object,
    },
    edit: {
      type: Boolean,
    },
    width:{
      type: String,
      default: '420px'
    },
    scene:{
      type: String,
    }
  },
  data() {
    return {
      info: {},
    };
  },
  watch: {
    turbine: {
      handler(val) {
        this.getTurbineInfo(val);
    // this.info = { ...val};

      },
       deep: true,
       immediate: true
    }
  },
  created() {
    this.info = { ...this.turbine };
    console.log("scene",this.scene);
  },
  methods: {
    handleBlur(e, key) {
      this.$emit('handleInputSave', { ...this.info, changeTarget: key});
    },
    async getTurbineInfo(val){
      console.log(val);
      const res = await this.$fetch(
        '/windfarm/station/getEnergyTurbineInfo',
        {
          params: {
            turbineId: val.turbineId
          },
          showLoading: false,
          showError: true
        }
      );
      this.info = res.data?.turbineInfo;
    }
  }
};
</script>

<style lang="less">
.tower-info-list {
  padding: 15px;
  width: var(--width);
  float:left;
  background: rgba(255, 255, 255, 0.9);

  li {
    width: 190px;
    font-size: 14px;
    float: left;
    display: inline-block;
    justify-content: space-between;
    padding: 5px;

    span{
      width: 80px;
      display: inline-block;
    }
  }
  .el-input {
    //margin-left: 40px;
    flex: 1;
    width: 95px;
  }
}
</style>
